import { DialogProgrammatic as Dialog, ToastProgrammatic as Toast } from 'buefy'
import { objectToCamel } from 'ts-case-convert'
import { get } from 'lodash'
import qs from 'qs'

console.log('************************')
console.log('* paymentStore Startup')
if (process.env.PROFILE_URL) {
  console.log(
    '* process.env.PROFILE_URL is properly set',
    process.env.PROFILE_URL
  )
} else {
  console.error('* process.env.PROFILE_URL is MISSING')
}
console.log('************************')

const PAYMENT_ACCOUNTS = [
  'VENMO_ACCOUNT',
  'PAYPAL_ACCOUNT',
  'VI_PHYSICAL_RELOADABLE_CARD',
  'VI_VIRTUAL_RELOADABLE_CARD',
  'VI_PAYPAL',
  'VI_VENMO',
  'VI_ACH',
] // Dispatch getAccounts only for these methods

const state = () => ({
  loading: [],
  payment: undefined,
  currentAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
  },
  showValidation: false,
  invalidFields: [],
  currValidAddress: [],
  // Redesign
  isPreferredMethod: false,
  // surveyQuestions
  loadingQuestions: false,
  questionsWithAnswers: [],
  questionsOnly: [],
})

const mutations = {
  setLoading(state, payload) {
    state.loading.push(payload.key)

    // unique the array
    state.loading = [...new Set(state.loading)]

    // remove
    if (!payload.value) {
      state.loading = state.loading.filter((e) => e !== payload.key)
    }
  },
  setPayment(state, payload) {
    state.payment = payload
  },
  setCurrentAddress(state, payload) {
    state.currentAddress = payload
  },
  setInvalidFields(state, payload) {
    state.invalidFields = payload
  },
  setValidAddress(state, payload) {
    state.currValidAddress = payload
  },
  // Redesign
  setIsPreferredMethod(state, payload) {
    state.isPreferredMethod = payload
  },
  setQuestions(state, { questions, loadAnswers }) {
    if (loadAnswers) {
      state.questionsWithAnswers = questions
    } else {
      state.questionsOnly = questions
    }
  },
}

const actions = {
  validate(context) {
    // Hijack validation for new Payments.  If it exists,
    // user has selected an already valid payment method.
    /* eslint-disable */

    const entityPaymentUuid = get(context, [
      'rootState',
      'dashboard',
      'selectedPayment',
      'entity_payment',
      'entity_payment_uuid',
    ])
    /* eslint-enable */
    if (entityPaymentUuid) {
      context.commit('setInvalidFields', [])

      return true
    }

    const textLengthRequirements = {
      routingNumber: {
        min: 9,
        max: 9,
      },
      accountNumber: {
        min: 6,
        max: 18,
      },
      zip: {
        min: 5,
        max: 5,
      },
      invitationCode: {
        min: 8,
        max: 8,
      },
      default: {
        min: 1,
        max: 199,
      },
      phoneNumber: {
        min: 10,
        max: 10,
      },
      email: {
        min: 8,
        max: 200,
      },
      name: {
        min: 1,
        max: 50,
      },
    }

    const invalidFields = []

    const requiredFieldsForVI = ['firstName', 'lastName', 'email']
    const requiredFieldsForVIPhysicalReloadableCards = [
      'address1',
      'city',
      'state',
      'zip',
    ]
    const requiredFieldForVenmo = ['phoneNumber']

    const paymentTypes = {
      VENMO_ACCOUNT: requiredFieldForVenmo,
      VI_VIRTUAL_RELOADABLE_CARD: requiredFieldsForVI,
      VI_PHYSICAL_RELOADABLE_CARD: requiredFieldsForVIPhysicalReloadableCards,
      VI_PAYPAL: requiredFieldsForVI,
      VI_VENMO: requiredFieldsForVI,
      VI_ACH: requiredFieldsForVI,
    }

    const paymentValidation = (thisPayment) => {
      const paymentOption = context.state.payment.option
      for (let i = 0; i < thisPayment.length; i++) {
        const requiredField = thisPayment[i]

        let min =
          textLengthRequirements[requiredField] &&
          textLengthRequirements[requiredField].min
            ? textLengthRequirements[requiredField].min
            : textLengthRequirements.default.min
        let max =
          textLengthRequirements[requiredField] &&
          textLengthRequirements[requiredField].max
            ? textLengthRequirements[requiredField].max
            : textLengthRequirements.default.max
        if (
          paymentOption.includes('RELOADABLE_CARD') &&
          thisPayment.length === 3
        ) {
          const field = requiredField.includes('Name') ? 'name' : 'email'
          min = textLengthRequirements[field].min
          max = textLengthRequirements[field].max
        }
        let response =
          paymentOption === 'VI_PHYSICAL_RELOADABLE_CARD'
            ? context.state.currentAddress[requiredField]
            : context.state.payment[requiredField]
        // handle date fields
        if (response !== undefined) {
          if (Object.prototype.toString.call(response) !== '[object Date]') {
            response = response.toString().trim()
          } else {
            const givenDate = new Date(response)
            const today = new Date()
            const year = today.getFullYear()
            const month = today.getMonth()
            const day = today.getDate()
            const oldestAllowedDate = new Date(year - 110, month, day)

            if (givenDate < oldestAllowedDate || givenDate > today) {
              invalidFields.push(requiredField)
              continue
            }
            continue
          }
        }

        // All other fields
        if (!response) {
          invalidFields.push(requiredField)
          continue
        }

        // console.log(`if (${response.length} < ${min} || ${response.length} > ${max}) {`)
        if (response && response.length >= min && response.length <= max) {
          // its ok
        } else {
          invalidFields.push(requiredField)
        }
      }
    }

    switch (context.state.payment.option) {
      case 'VENMO_ACCOUNT':
        paymentValidation(paymentTypes.VENMO_ACCOUNT)
        break
      case 'VI_PHYSICAL_RELOADABLE_CARD':
        paymentValidation(paymentTypes.VI_PHYSICAL_RELOADABLE_CARD)
        break
      case 'VI_VIRTUAL_RELOADABLE_CARD':
      case 'VI_PAYPAL':
      case 'VI_VENMO':
      case 'VI_ACH':
        // these SKU'S  have no validation
        break
      default:
        console.log('default')
        return false
    }
    context.commit('setInvalidFields', invalidFields)

    return invalidFields.length === 0
  },

  // Redesign
  validateFields(context, requiredFields) {
    const textLengthRequirements = {
      zip: {
        min: 5,
        max: 5,
      },
      invitationCode: {
        min: 8,
        max: 8,
      },
      default: {
        min: 1,
        max: 199,
      },
      phoneNumber: {
        min: 10,
        max: 10,
      },
      email: {
        min: 8,
        max: 200,
      },
      name: {
        min: 1,
        max: 50,
      },
    }

    const invalidFields = []

    const requiredFieldForVenmo = ['phoneNumber']
    const requiredFieldForReloadableVirtualCard = requiredFields
    const requiredFieldForReloadablePhysicalCard = requiredFields

    const paymentTypes = {
      VENMO_ACCOUNT: requiredFieldForVenmo,
      VI_VIRTUAL_RELOADABLE_CARD: requiredFieldForReloadableVirtualCard,
      VI_PHYSICAL_RELOADABLE_CARD: requiredFieldForReloadablePhysicalCard,
    }

    const paymentValidation = (thisPayment) => {
      const paymentOption = context.state.payment.option
      for (let i = 0; i < thisPayment.length; i++) {
        const requiredField = thisPayment[i]

        let min =
          textLengthRequirements[requiredField] &&
          textLengthRequirements[requiredField].min
            ? textLengthRequirements[requiredField].min
            : textLengthRequirements.default.min

        let max =
          textLengthRequirements[requiredField] &&
          textLengthRequirements[requiredField].max
            ? textLengthRequirements[requiredField].max
            : textLengthRequirements.default.max

        if (
          paymentOption.includes('VISA_ISSUING') &&
          thisPayment.length === 3
        ) {
          const field = requiredField.includes('Name') ? 'name' : 'email'
          min = textLengthRequirements[field].min
          max = textLengthRequirements[field].max
        }

        let response =
          paymentOption === 'VI_PHYSICAL_RELOADABLE_CARD'
            ? context.state.currentAddress[requiredField]
            : context.state.payment[requiredField]
        if (
          paymentOption === 'VI_PHYSICAL_RELOADABLE_CARD' &&
          requiredField === 'city' &&
          !/^[a-zA-Z ]*$/.test(response) &&
          !invalidFields.includes(requiredField)
        ) {
          invalidFields.push(requiredField)
        }
        // handle date fields
        if (response !== undefined && response !== null) {
          if (Object.prototype.toString.call(response) !== '[object Date]') {
            response = response.toString().trim()
          } else {
            const givenDate = new Date(response)
            const today = new Date()
            const year = today.getFullYear()
            const month = today.getMonth()
            const day = today.getDate()
            const oldestAllowedDate = new Date(year - 110, month, day)

            if (givenDate < oldestAllowedDate || givenDate > today) {
              invalidFields.push(requiredField)
              continue
            }
            continue
          }
        }
        // All other fields
        if (!response) {
          invalidFields.push(requiredField)
          continue
        }
        // console.log(`if (${response.length} < ${min} || ${response.length} > ${max}) {`)
        if (response && response.length >= min && response.length <= max) {
          // its ok
        } else {
          invalidFields.push(requiredField)
        }
      }
    }

    switch (context.state.payment.option) {
      case 'VENMO_ACCOUNT':
        paymentValidation(paymentTypes.VENMO_ACCOUNT)
        break
      case 'VI_VIRTUAL_RELOADABLE_CARD':
      case 'VI_PAYPAL':
      case 'VI_VENMO':
      case 'VI_ACH':
        paymentValidation(paymentTypes.VI_VIRTUAL_RELOADABLE_CARD)
        break
      case 'VI_PHYSICAL_RELOADABLE_CARD':
        paymentValidation(paymentTypes.VI_PHYSICAL_RELOADABLE_CARD)
        break
      default:
        return false
    }
    context.commit('setInvalidFields', invalidFields)
    return invalidFields.length === 0
  },
  // Redesign
  async postNewPaymentProduct(context) {
    try {
      context.commit('setLoading', {
        key: 'postNewPaymentProduct',
        value: true,
      })

      // convert camelCased object keys into
      // snake_cased for db storage
      let camelizedCasedPayload = objectToCamel(context.state.payment)
      if (context.state.payment.option === 'VI_PHYSICAL_RELOADABLE_CARD') {
        const addressUuid = context.state.currentAddress.address_uuid
          ? context.state.currentAddress.address_uuid
          : ''
        camelizedCasedPayload = {
          ...camelizedCasedPayload,
          ...context.state.currentAddress,
          address_uuid: addressUuid,
        }
      }
      const newProduct = await this.$axios.$post(
        '/PROFILE_URL/payments/product',
        camelizedCasedPayload
      )
      await context.dispatch('dashboard/getPaymentProducts', {}, { root: true })
      const paymentOption = context.state.payment.option

      if (PAYMENT_ACCOUNTS.includes(paymentOption)) {
        await context.dispatch(
          'dashboard/getPaymentAccounts',
          { ...newProduct },
          { root: true }
        )
      }
      context.commit('setLoading', {
        key: 'postNewPaymentProduct',
        value: false,
      })
      return newProduct
    } catch (error) {
      console.log(error)
      let paymentProductError
      if (
        context.state.payment.option === 'PAYPAL_ACCOUNT' ||
        context.state.payment.option === 'VENMO_ACCOUNT'
      ) {
        if (context.state.payment.option === 'PAYPAL_ACCOUNT') {
          paymentProductError = this.app.i18n.t(
            'payments__paypal_account__setup_error'
          )
        } else if (context.state.payment.option === 'VENMO_ACCOUNT') {
          paymentProductError = this.app.i18n.t(
            'payments__venmo_account__setup_error'
          )
        }
        Dialog.alert({
          title: this.app.i18n.t('error'),
          message: paymentProductError,
          type: 'is-danger',
          hasIcon: true,
          confirmText: 'Ok',
        })
      }
    } finally {
      context.commit('setLoading', {
        key: 'postNewPaymentProduct',
        value: false,
      })
    }
  },
  async postNewPaymentProductAccount(context, entityPaymentVendorProductUuid) {
    try {
      context.commit('setLoading', {
        key: 'postNewPaymentProductAccount',
        value: true,
      })
      let payload
      let newAccount
      switch (context.state.payment.option) {
        case 'PAYPAL_ACCOUNT':
          payload = {
            entityPaymentVendorProductUuid,
            authCode: context.state.payment.authCode,
          }
          newAccount = await this.$axios.$post(
            '/PROFILE_URL/payments/product/account',
            payload
          )
          await context.dispatch(
            'dashboard/getPaymentAccounts',
            { ...newAccount },
            { root: true }
          )
          context.commit('setLoading', {
            key: 'postNewPaymentProductAccount',
            value: false,
          })

          // Redesign feature flag
          break
        case 'VENMO_ACCOUNT':
          payload = {
            entityPaymentVendorProductUuid,
            phoneNumber: context.state.payment.phoneNumber,
          }
          newAccount = await this.$axios.$post(
            '/PROFILE_URL/payments/product/account',
            payload
          )
          await context.dispatch(
            'dashboard/getPaymentAccounts',
            { ...newAccount },
            { root: true }
          )
          context.commit('setLoading', {
            key: 'postNewPaymentProductAccount',
            value: false,
          })
          break

        default:
          console.log('unsupported payment type')
          break
      }
      return newAccount
    } catch (error) {
      console.log('postNewPaymentProductAccount', error)
      console.log(error.response)

      /* eslint-disable */
      let paymentAccountError
      let paymentsError = get(error, [
        'response',
        'data',
        'error during POST request, additional details have been logged',
      ])
      if (paymentsError ? true : false) {
        if (context.state.payment.option === 'PAYPAL_ACCOUNT') {
          paymentAccountError = this.app.i18n.t(
            'payments__paypal_account__setup_error'
          )
        } else if (context.state.payment.option === 'VENMO_ACCOUNT') {
          paymentAccountError = this.app.i18n.t(
            'payments__venmo_account__setup_error'
          )
        } else if (
          context.state.payment.option.includes('DIRECT') ||
          context.state.payment.option.includes('ISSUING')
        ) {
          paymentAccountError = this.app.i18n.t(
            'payments__stripe_error_message'
          )
        }
      }
      /* eslint-enable */
      Dialog.alert({
        title: this.app.i18n.t('error'),
        message: paymentAccountError,
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Ok',
      })
      return error.response
    } finally {
      context.commit('setLoading', {
        key: 'postNewPaymentProductAccount',
        value: false,
      })
    }
  },
  // Disconnecting PayPal & Venmo account
  async disconnectPaymentAccount(context, entityPaymentUuid) {
    try {
      context.commit('setLoading', {
        key: 'disconnectPaymentAccount',
        value: true,
      })
      let payload
      switch (context.state.payment.option) {
        case 'PAYPAL_ACCOUNT':
          payload = {
            option: context.state.payment.option,
          }
          await this.$axios.$delete(
            `/PROFILE_URL/payments/product/account/${entityPaymentUuid}`,
            payload
          )
          context.commit('dashboard/removePaymentAccount', 'PayPal', {
            root: true,
          })
          await context.dispatch(
            'unsetPreferredPaymentAccount',
            entityPaymentUuid
          )
          Dialog.alert({
            title: this.app.i18n.t('disconnected_payment_account'),
            message: this.app.i18n.t('paypal__payment__disconnected_message'),
            confirmText: 'Ok',
          })
          break

        case 'VENMO_ACCOUNT':
          payload = {
            option: context.state.payment.option,
          }
          await this.$axios.$delete(
            `/PROFILE_URL/payments/product/account/${entityPaymentUuid}`,
            payload
          )
          context.commit('dashboard/removePaymentAccount', 'Venmo', {
            root: true,
          })
          await context.dispatch(
            'unsetPreferredPaymentAccount',
            entityPaymentUuid
          )
          Dialog.alert({
            title: this.app.i18n.t('disconnected_payment_account'),
            message: this.app.i18n.t('venmo__payment__disconnected_message'),
            confirmText: 'Ok',
          })
          break
        default:
          console.log('unsupported payment type')
          break
      }
    } catch (error) {
      let paymentDisconnectErrorMessage, paymentDisconnectErrorTitle
      // Showing different error message if there is an imminent payment for any of the payout methods.
      if (get(error, ['response', 'data', 'error'])) {
        paymentDisconnectErrorTitle = ''
        paymentDisconnectErrorMessage = `${this.app.i18n.t(
          'disconnecting_account_having_imminent_payment'
        )} <a href=${this.app.i18n.t(
          'dashboard__support_link_url'
        )} target="_blank">${this.app.i18n.t(
          'dashboard__support_link_text'
        )}</a>`
      } else if (context.state.payment.option === 'PAYPAL_ACCOUNT') {
        paymentDisconnectErrorTitle = this.app.i18n.t(
          'disconnecting_paypal_payment_account_failed'
        )
        paymentDisconnectErrorMessage = this.app.i18n.t(
          'paypal__disconnect_failed_message'
        )
      } else if (context.state.payment.option === 'VENMO_ACCOUNT') {
        paymentDisconnectErrorTitle = this.app.i18n.t(
          'disconnecting_venmo_payment_account_failed'
        )
        paymentDisconnectErrorMessage = this.app.i18n.t(
          'venmo__disconnect_failed_message'
        )
      }

      context.commit('setLoading', {
        key: 'disconnectPaymentAccount',
        value: false,
      })
      Dialog.alert({
        title: paymentDisconnectErrorTitle,
        message: paymentDisconnectErrorMessage,
        type: 'is-danger',
        hasIcon: true,
        confirmText: 'Ok',
      })
    }
  },
  // unsetting preferred payment method while disconnecting
  async unsetPreferredPaymentAccount(context, entityPaymentUuid) {
    try {
      let entityDetail
      if (context.state.payment.option) {
        entityDetail = await this.$axios.$get('/AUTH_URL/user')
        context.commit('setLoading', {
          key: 'disconnectPaymentAccount',
          value: false,
        })
        if (
          entityDetail.meta.autopay.entity_payment_uuid === entityPaymentUuid
        ) {
          await context.dispatch(
            'dashboard/updateOnboarding',
            {
              autopay: {
                enabled: true,
                entity_payment_uuid: null,
              },
            },
            { root: true }
          )
        }
      }
    } catch (error) {
      console.log('error getting entity detail', error.response)
    }
  },
  // Redesign
  async getPreferredPaymentAccount(context, entityPaymentUuid) {
    try {
      context.commit('setLoading', {
        key: 'getPreferredPaymentAccount',
        value: true,
      })
      const entityDetail = await this.$axios.$get('/AUTH_URL/user')
      if (entityDetail.meta.autopay.entity_payment_uuid === entityPaymentUuid) {
        context.commit('setIsPreferredMethod', true)
      } else {
        context.commit('setIsPreferredMethod', false)
      }
      context.commit('setLoading', {
        key: 'getPreferredPaymentAccount',
        value: false,
      })
    } catch (error) {
      context.commit('setLoading', {
        key: 'getPreferredPaymentAccount',
        value: false,
      })
      console.log('error getting entity detail', error.response)
    }
  },
  deletePayment(context, entityPaymentUuid) {
    Dialog.confirm({
      title: this.app.i18n.t('confirm'),
      message: this.app.i18n.t('payments__delete_question'),
      cancelText: this.app.i18n.t('cancel'),
      confirmText: this.app.i18n.t('confirm'),
      type: 'is-warning',
      hasIcon: true,
      ariaRole: 'alertdialog',
      ariaModal: true,
      onConfirm: async () => {
        context.commit('setLoading', { key: 'deletePayment', value: true })
        try {
          await this.$axios.$delete(
            `/PROFILE_URL/payments/product/account/${entityPaymentUuid}`
          )
          await context.dispatch(
            'dashboard/getPaymentAccounts',
            {},
            { root: true }
          )
        } catch (error) {
          context.commit('setLoading', { key: 'deletePayment', value: false })
          const errorMessage = error.response.data.message

          Dialog.alert({
            title: 'Error',
            message: errorMessage,
            type: 'is-danger',
            hasIcon: true,
            ariaRole: 'alertdialog',
            ariaModal: true,
          })
          console.log(error)
          console.log(error.response.data.message)
        } finally {
          context.commit('setLoading', { key: 'deletePayment', value: false })
        }
      },
    })
  },
  async updateMeta(context, { entityUuid, questions, firstName, lastName }) {
    try {
      context.commit('setLoading', { key: 'updateMeta', value: true })
      const data = questions.map((question) => {
        return {
          instructions_entity_uuid: entityUuid,
          responder_entity_uuid: entityUuid,
          subject_entity_type: question.subject.entity_type,
          subject_entity_code: entityUuid,
          locale: this.$i18n.locale,
          question_hash: question.question_hash,
          response_body: {
            type: 'string',
            value: question.code === 'first_name' ? firstName : lastName,
          },
        }
      })
      await this.$axios.$post(`/CORE_URL/smart-surveys/me/responses`, data)
    } catch (error) {
      console.log('Error occurred while updating meta', error)
      Toast.open({
        message: "Oops, we've encountered a problem. Please try again.",
        type: 'is-danger',
        duration: 5000,
      })
    } finally {
      context.commit('setLoading', { key: 'updateMeta', value: false })
    }
  },
  async loadQuestions(context, { codes, loadAnswers }) {
    try {
      context.commit('setLoading', { key: 'loadSurveyQuestions', value: true })

      const questionsCodes = codes.map((code) => code.code)
      const questions = await this.$axios.$get(
        '/CORE_URL/smart-surveys/me/questions',
        {
          params: {
            codes: questionsCodes,
            answers: loadAnswers,
          },
          paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: 'repeat' }),
        }
      )

      context.commit('setQuestions', { questions, loadAnswers })
    } catch (e) {
      console.log('Error getting questions', e)
    } finally {
      context.commit('setLoading', { key: 'loadSurveyQuestions', value: false })
    }
  },
  loadProfileQuestions(context, payload) {
    context.dispatch('loadQuestions', {
      codes: payload,
      loadAnswers: true,
    })
  },
}

const getters = {
  loading(state) {
    return state.loading.length !== 0
  },
  currValidAddress(state) {
    return state.currValidAddress
  },
  localizedMessage: (state) => (key, selectedLocale, i18n) => {
    selectedLocale = !selectedLocale ? 'en' : selectedLocale

    let result = null
    console.log('i18n: ', i18n)
    console.log('key: ', key)
    if (i18n) {
      result = i18n.messages[selectedLocale].payments[key]
    } else {
      result = ''
    }
    return result
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
